import { Dispatch } from "redux";

import { SubTasksStateAction } from "@reducers/types/taskManagement/sub-tasks-state";

import {
  GET_TM_SUB_TASKS,
  GET_SINGLE_TM_SUB_TASKS,
  CREATE_TM_SUB_TASKS,
  UPDATE_TM_SUB_TASKS,
  DELETE_TM_SUB_TASKS,
} from "./types";

import { SubTasksCreateType } from "@type/taskManagement/subTasks";

import {
  fetchSubTasks,
  fetchSubTasksById,
  createSubTasks,
  updateSubTasks,
  deleteSubTasks,
} from "@api/taskManagement/subTasks";

export const subTasksFetchActionHandler = (
  id: string | number,
  query: any
) => async (dispatch: Dispatch<SubTasksStateAction>) => {
  dispatch({ type: GET_TM_SUB_TASKS.LOADING, payload: true });

  try {
    const res = await fetchSubTasks(id, query);

    const { data, page, size, total } = res.data || {};

    dispatch({
      type: GET_TM_SUB_TASKS.SUCCESS,
      payload: {
        data,
        pagination: {
          page,
          size,
          total,
        },
      },
    });
  } catch (err) {
    dispatch({ type: GET_TM_SUB_TASKS.ERROR, payload: err });
  }
};

export const subTasksByIdFetchActionHandler = (
  id: string | number,
  id2: string | number
) => async (dispatch: Dispatch<SubTasksStateAction>) => {
  dispatch({ type: GET_SINGLE_TM_SUB_TASKS.LOADING, payload: true });

  try {
    const res = await fetchSubTasksById(id, id2);

    dispatch({
      type: GET_SINGLE_TM_SUB_TASKS.SUCCESS,
      payload: res.data || {},
    });
  } catch (err) {
    dispatch({ type: GET_SINGLE_TM_SUB_TASKS.ERROR, payload: err });
  }
};

export const subTasksCreateActionHandler = (
  id: string | number,
  data: SubTasksCreateType
) => async (dispatch: Dispatch<SubTasksStateAction>) => {
  dispatch({ type: CREATE_TM_SUB_TASKS.LOADING, payload: true });

  try {
    const res = await createSubTasks(id, data);

    dispatch({ type: CREATE_TM_SUB_TASKS.SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: CREATE_TM_SUB_TASKS.ERROR, payload: err });
  }
};

export const subTasksUpdateActionHandler = (
  id: string | number,
  id2: string | number,
  data: SubTasksCreateType
) => async (dispatch: Dispatch<SubTasksStateAction>) => {
  dispatch({ type: UPDATE_TM_SUB_TASKS.LOADING, payload: true });

  try {
    const res = await updateSubTasks(id, id2, data);

    dispatch({
      type: UPDATE_TM_SUB_TASKS.SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({ type: UPDATE_TM_SUB_TASKS.ERROR, payload: err });
  }
};

export const subTasksDeleteActionHandler = (
  taskId: string | number,
  id: number
) => async (dispatch: Dispatch<SubTasksStateAction>) => {
  dispatch({ type: DELETE_TM_SUB_TASKS.LOADING, payload: true });

  try {
    const res = await deleteSubTasks(taskId, id);

    dispatch({ type: DELETE_TM_SUB_TASKS.SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: DELETE_TM_SUB_TASKS.ERROR, payload: err });
  }
};
